import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { AuctionsPromoItem } from '../../types';

export default function PromotionCard({
    title,
    mediaUri,
    content,
    linkText,
    linkUri,
}: AuctionsPromoItem) {
    const mediaUrl = mediaUri?.fields?.file?.url;
    const mediaAlt = mediaUri?.fields?.title;

    return (
        <>
            <article key={title} className="promotion-card">
                <div className="promotion-card-main">
                    <div className="promotion-card-image">
                        <img src={mediaUrl} alt={mediaAlt} />
                    </div>
                    <div className="promotion-card-text">
                        <h3 className="kmx-typography--display-2">{title}</h3>
                        <p className="kmx-typography--body-1">
                            {documentToReactComponents(content)}
                        </p>
                        <a
                            className="kmx-typography--body-1"
                            tabIndex={-1}
                            href={linkUri}
                            target="_blank"
                            rel="noreferrer">
                            {' '}
                            {linkText}{' '}
                        </a>
                    </div>
                </div>
            </article>
        </>
    );
}
